import { awsAccount, awsRegion } from "../services/constants"

export const userArn = (userName: string) => `arn:aws:iam::${awsAccount}:user/${userName}`
export const policyArn = (policyName: string) => `arn:aws:iam::${awsAccount}:policy/${policyName}`
export const tableArn = (tableName: string) => `arn:aws:dynamodb:${awsRegion}:${awsAccount}:table/${tableName}`
export const indexArn = (tableName: string, indexName: string) => `arn:aws:dynamodb:${awsRegion}:${awsAccount}:table/${tableName}/index/${indexName}`
export const roleArn = (roleName: string) => `arn:aws:iam::${awsAccount}:role/${roleName}`
export const sessionName = (userName: string) => `${userName}.session`
export const tableAction = (action: string) => `dynamodb:${action}`
